<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="任务名称" name="job_name"></c-form-item>
					<c-form-item type="datetime" label="创建时间" start-name="start_create_date" end-name="end_create_date"></c-form-item>
					<c-form-item type="checkbox" label="执行状态" name="state" :options="state" ></c-form-item>
				</c-form>
			</m-search>
			
			<c-table ref="table" code="">
				<c-table-column
					label="任务名称"
					name="job_name"
				></c-table-column>
				
				<c-table-column
					label="任务状态"
					name="state"
				>
                    <template v-slot="{data}">
                      <span v-if="data.state == 0" style="color:#999">{{stateName[data.state]}}</span>
                      <span v-if="data.state == 1" style="color:blue">{{stateName[data.state]}}</span>
                      <span v-if="data.state == 2" style="color:green">{{stateName[data.state]}}</span>
                      <span v-if="data.state == 3" style="color:red">{{stateName[data.state]}}</span>
                    </template>
				</c-table-column>
				
				<c-table-column
					label="任务ID"
					name="id"
				></c-table-column>
				
				<c-table-column
					label="任务创建时间"
					name="create_date"
					width="150"
				></c-table-column>
				
				<!-- <c-table-column
					label="导出条件"
					name="query_parameter"
					width="400"
				></c-table-column> -->

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
				>
					<template v-slot="{data}">
						<c-table-button v-if="data.state==2" @click="downloadFile(data.job_name,data.file_path)">下载</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_task_center_list',
		
		data() {
			return {
				stateName: {
					0: '待执行',
					1: '执行中',
					2: '执行完成',
					3: '执行异常'
				},
				state: [{
						name: '待执行',
						value: "0"
					},{
						name: '执行中',
						value: "1"
					},{
						name: '执行完成',
						value: "2"
					},{
						name: '执行异常',
						value: "3"
					}
				]
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/export_job/list',
					data
				});
			},
			downloadFile(file_name,file_path) {
                var suffix = file_path.substring(file_path.lastIndexOf('.')+1)

                this.download({
                    fileName:file_name + '.'+suffix,
                    url: file_path,
                    loading: {
                        message: '数据文件下载中...'
                    }
                })
			}
		}
	}
</script>